import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button } from '../Button';
import { cn } from '../../../../utils/styles';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from '../Command';
import Icons from '../../Icons/Icons';
import { AccountManagementRes } from '../../../../infoTrac/components/Pages/AccountManagement/columns';

export interface IComboBoxItem {
  value: string;
  label: string;
}

interface ICombobox {
  items: IComboBoxItem[];
  selected: AccountManagementRes;
  handleSelect: (payload?: IComboBoxItem) => void;
  triggerClassName?: string;
  placeholder?: string;
  isTrim?: boolean;
}

function Combobox({ items, triggerClassName, placeholder, selected, handleSelect, isTrim }: ICombobox) {
  const [open, setOpen] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState<string>('');

  useEffect(() => {
    let label: string | undefined;

    label = items?.find(item => item.value === selected.id)?.label;

    if (selected && isTrim && label) {
      label = `...${label.slice(-4)}`;
    } else {
      label = placeholder || 'Select...';
    }

    setSelectedLabel(label);
  }, [selected]);

  const handleChange = (payload?: IComboBoxItem) => {
    handleSelect(payload);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          role="combobox"
          aria-expanded={open}
          className={cn('w-[115px] justify-between !bg-primary text-white', triggerClassName)}
        >
          {selectedLabel}
          <Icons.ArrowRight className="rotate-90 ml-[5px] h-[20px] w-[20px] shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[270px] px-[20px] py-[10px] rounded-lg">
        <Command>
          <CommandInput placeholder="Search" />
          <CommandEmpty>No found.</CommandEmpty>
          <CommandList>
            {items.map(item => (
              <CommandItem
                key={item.value}
                value={item.value}
                onClick={() => {
                  handleChange(item.value === selected.id ? undefined : item);
                }}
                onSelect={currentValue => {
                  handleChange(currentValue === selected.id ? undefined : item);
                }}
              >
                <Icons.UserAccount className="mr-[10px] text-primary" />
                {item.label}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

Combobox.defaultProps = {
  triggerClassName: '',
  placeholder: undefined,
  isTrim: false,
};

export default Combobox;
